if (!customElements.get("availability-content")) {
  class PickupAvailability extends HTMLElement {
    constructor() {
      super();

      this.focusElement = null;
      this.drawer = null;

      this.handleKeyDown = this.handleKeyDown.bind(this);

      document.addEventListener("keydown", this.handleKeyDown);

      if (!this.hasAttribute("available")) return;

      this.fetchAvailability(this.dataset.variantId);
    }

    fetchAvailability(variantId) {
      const variantSectionUrl =
        `${this.dataset.rootUrl}variants/${variantId}/?section_id=pickup-availability`;

      fetch(variantSectionUrl)
        .then((response) => response.text())
        .then((text) => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, "text/html")
            .querySelector(".shopify-section");

          if (!sectionInnerHTML) return;

          this.renderPreview(sectionInnerHTML);
        })
        .catch((error) => {
          console.error("Pickup availability error:", error);
        });
    }

    renderPreview(sectionInnerHTML) {
      const availabilityContent =
        sectionInnerHTML.querySelector("availability-content");

      if (!availabilityContent) {
        this.removeAttribute("available");
        this.innerHTML = "";
        this.removeExistingDrawer();
        return;
      }

      /*
       * Alten Drawer entfernen, falls durch einen Variantenwechsel
       * bereits ein Drawer direkt im Body vorhanden ist.
       */
      this.removeExistingDrawer();

      this.innerHTML = sectionInnerHTML.innerHTML;
      this.setAttribute("available", "");

      const drawer = this.querySelector("availability-drawer");

      if (drawer) {
        /*
         * Entscheidend:
         * Drawer aus der Produktsektion herausnehmen und direkt
         * unter <body> einfügen. Dadurch wird der Stacking Context
         * der Produktsektion verlassen.
         */
        document.body.appendChild(drawer);
        this.drawer = drawer;
      }

      const drawerTrigger = this.querySelector("[data-drawer-main-head]");

      if (drawerTrigger) {
        drawerTrigger.addEventListener(
          "click",
          this.openDrawer.bind(this)
        );
      }

      this.closeDrawer();
    }

    openDrawer(event) {
      event.preventDefault();

      const drawer = this.drawer;

      if (!drawer) return;

      drawer.classList.add("is-visible");
      document.body.classList.add("overflow-hidden");

      setTimeout(() => {
        this.focusElement = event.currentTarget;

        if (
          drawer &&
          typeof trapFocusElements === "function"
        ) {
          trapFocusElements(drawer);
        }
      }, 300);
    }

    closeDrawer() {
      const drawer = this.drawer;

      if (!drawer) return;

      const closeElements =
        drawer.querySelectorAll("[data-drawer-close]");

      closeElements.forEach((element) => {
        element.addEventListener("click", (event) => {
          event.preventDefault();

          this._closeDrawer(drawer);

          if (this.focusElement) {
            this.focusElement.focus();
          }

          this.focusElement = null;
        });
      });
    }

    _closeDrawer(drawer) {
      drawer.classList.remove("is-visible");
      document.body.classList.remove("overflow-hidden");

      if (typeof removeTrapFocus === "function") {
        removeTrapFocus();
      }
    }

    removeExistingDrawer() {
      if (
        this.drawer &&
        this.drawer.parentElement === document.body
      ) {
        this.drawer.remove();
      }

      this.drawer = null;
    }

    handleKeyDown(event) {
      if (
        event.key === "Escape" &&
        this.drawer?.classList.contains("is-visible")
      ) {
        this._closeDrawer(this.drawer);

        if (this.focusElement) {
          this.focusElement.focus();
        }

        this.focusElement = null;
      }
    }

    disconnectedCallback() {
      document.removeEventListener(
        "keydown",
        this.handleKeyDown
      );

      this.removeExistingDrawer();
    }
  }

  customElements.define(
    "availability-content",
    PickupAvailability
  );
}
